import { ValidatorFn, FormControl } from '@angular/forms';

export function fileCountValidator(currentCnt: number): ValidatorFn {
  
  let MAX_UPLOAD_FILES: number = 10;

  return (control: FormControl) => {

    const file: File = control.value;
    let returnFn = null; // This is a Map containing a property and a boolean
  
    if (file && currentCnt >= MAX_UPLOAD_FILES) {
        returnFn = {
            invalidFileCount: true
        };
    }

    return returnFn;
  };
}